/**
 * WebSmDelivered — terminal "mission requested" confirmation (ported from
 * Glow's WebSmDelivered_type.jsx). Options: Title / Message / Submessage
 *   / ReplayLabel / BgColor / AccentColor / GlyphColor. Emits CLICK1 (replay).
 */
import type { CSSProperties } from "react";
import {
  CARD_CLASS,
  LINK_BTN_CLASS,
  MESSAGE_CLASS,
  SECTION_CLASS,
  SUBMESSAGE_CLASS,
  TITLE_CLASS,
  stepVars,
} from "./step-shell";
import type { StepTypeProps } from "./types";

export default function WebSmDeliveredType({
  getOpt,
  dispatch,
}: StepTypeProps) {
  const bg = getOpt("BgColor") || "#0a0809";
  const accent = getOpt("AccentColor") || "#d6a94e";
  const glyph = getOpt("GlyphColor") || "#f0c674";

  const title = getOpt("Title") || "MISSION REQUESTED";
  const message =
    getOpt("Message") || "Your handler will be talking with you via text.";
  const submessage = getOpt("Submessage") || "Watch your phone.";
  // No `||` default: the button below is guarded on this being non-empty,
  // and a fallback here made that guard unreachable — the replay link could
  // never be turned off. The default label lives in the builder template
  // instead, which seeds the option, so clearing it hides the button.
  const replayLabel = getOpt("ReplayLabel");

  const glyphVars = { "--sm-glyph-halo": `${glyph}66` } as CSSProperties;

  return (
    <section
      style={stepVars({ accent, bg })}
      className={`${SECTION_CLASS} px-4 py-12`}
    >
      <div className={CARD_CLASS}>
        <div className="mt-[2px] mb-[18px] text-center">
          <svg
            viewBox="0 0 100 80"
            width="86"
            height="69"
            style={glyphVars}
            className="overflow-visible [filter:drop-shadow(0_0_18px_var(--sm-glyph-halo))]"
          >
            <path
              d="M8 14 a8 8 0 0 1 8 -8 h44 a8 8 0 0 1 8 8 v22 a8 8 0 0 1 -8 8 h-30 l-12 11 v-11 h-2 a8 8 0 0 1 -8 -8 z"
              fill="none"
              stroke={glyph}
              strokeWidth="3.4"
            />
            <circle cx="26" cy="25" r="3" fill={glyph} />
            <circle cx="38" cy="25" r="3" fill={glyph} />
            <circle cx="50" cy="25" r="3" fill={glyph} />
            <path
              d="M50 46 h34 a7 7 0 0 1 7 7 v14 a7 7 0 0 1 -7 7 h-2 v9 l-10 -9 h-22 a7 7 0 0 1 -7 -7 v-14 a7 7 0 0 1 7 -7 z"
              fill={glyph}
              opacity="0.85"
            />
          </svg>
        </div>

        <div className={TITLE_CLASS}>{title}</div>
        {message ? <div className={MESSAGE_CLASS}>{message}</div> : null}
        {submessage ? (
          <div className={SUBMESSAGE_CLASS}>{submessage}</div>
        ) : null}

        {replayLabel ? (
          <button
            type="button"
            onClick={() => dispatch("CLICK1")}
            className={LINK_BTN_CLASS}
          >
            {replayLabel}
          </button>
        ) : null}
      </div>
    </section>
  );
}
